import { render } from "./CHero.vue?vue&type=template&id=11f15b8f&scoped=true"
const script = {}

import "./CHero.vue?vue&type=style&index=0&id=11f15b8f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f15b8f"]])

export default __exports__